import type { FC } from 'react';
import { CheckIcon as Check } from '@/components/icons/CheckIcon';
import { DashIcon as Dash } from '@/components/icons/DashIcon';
import { ThumbDownIcon as ThumbDown } from '@/components/icons/ThumbDownIcon';
import { ThumbUpIcon as ThumbUp } from '@/components/icons/ThumbUpIcon';
import H3 from '@/components/typography/h3';
import type { BonusOfferCons, BonusOfferPros } from '@/types/bookmaker';

interface ProsConsListsProps {
  pros: BonusOfferPros;
  cons: BonusOfferCons;
}

export const ProsConsLists: FC<ProsConsListsProps> = ({ pros, cons }) => {
  return (
    <div
      className="mt-3 grid grid-cols-1 gap-5 sm:grid-cols-2 md:gap-3"
      id="lists"
    >
      <div>
        <div className="ml-1 flex flex-row items-center gap-4">
          <ThumbUp
            className="m-[14px] scale-[2] text-green-o50 opacity-50"
            desc="Thumbs up icon for pros section"
            title="Pros"
          />
          <H3>Pros</H3>
        </div>
        <ul className="mt-5 flex flex-col gap-1">
          {Object.values(pros).map((pro) => (
            <li className="flex flex-row items-center gap-3" key={pro}>
              <Check
                className="m-1 block text-green"
                desc="Check mark icon"
                title="Check"
              />
              <p className="max-w-[240px] font-normal text-4 text-white leading-6">
                {pro}
              </p>
            </li>
          ))}
        </ul>
      </div>
      <div>
        <div className="ml-1 flex flex-row items-center gap-4">
          <ThumbDown
            className="m-[14px] scale-[2] text-red-o50 opacity-50"
            desc="Thumbs down icon for cons section"
            title="Cons"
          />
          <H3>Cons</H3>
        </div>
        <ul className="mt-5 flex flex-col gap-1">
          {Object.values(cons).map((con) => (
            <li className="flex flex-row items-center gap-3" key={con}>
              <Dash
                className="m-1 block text-gray"
                desc="Dash icon for negative points"
                title="Dash"
              />
              <p className="max-w-[240px] font-normal text-4 text-white leading-6">
                {con}
              </p>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
